export enum SalaryHistoricVariableHandlingOption {
KeepFirst,
KeepLast,
Average,
}
